import { useErrorInlineNotification } from '@/components/ErrorInlineNotification/ErrorInlineNotification';
import { createContext, ReactNode, useContext, useMemo } from 'react';

type InlineErrorContextType = {
  setError: (error: Error) => void;
  ErrorContextHolder: ReactNode;
};

const InlineErrorContext = createContext<InlineErrorContextType | null>(null);

export const InlineErrorProvider = ({ children }: { children: ReactNode }) => {
  const [{ setError }, ErrorContextHolder] = useErrorInlineNotification();

  const value = useMemo(
    () => ({ setError, ErrorContextHolder }),
    [setError, ErrorContextHolder]
  );

  return (
    <InlineErrorContext.Provider value={value}>
      {children}
    </InlineErrorContext.Provider>
  );
};

export const useErrorInline = () => {
  const context = useContext(InlineErrorContext);
  if (!context)
    throw new Error(
      'useErrorInline must be used within InlineErrorContextProvider'
    );
  return context;
};
